<svg width="25" height="25" viewBox="0 0 100 100">
  <g>
    <mask x="0" y="0" id="half-config" class="CONFIG-mask">
      <rect x="-3%" y="0%" width="125" height="100%" [attr.fill]="getFill(evento)" />
    </mask>
    <rect class="CONFIG-cover" x="-1%" y="1%" height="100%" width="102%" rx="20%" mask="url(#half-config)"
      [attr.fill]="getFill(evento)" stroke="black" stroke-width="4"></rect>
  </g>
</svg>